import React, { useEffect } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import NotFound from '../../templates/NotFound';
import OptinMailError from '../../templates/OptinMailError';
import '@common/component/pages/app.css';
import MailDeliveryTop from '../../templates/MailDeliveryTop';
import MailDeliveryUnsubscribed from '../../templates/MailDeliveryUnsubscribed';
import SystemMaintenance from '../../templates/SystemMaintenance';
import { SCREEN } from '@common/Common';
import OptinMail from '../../templates/OptinMail';
import OptinMailtDone from '../../templates/OptinMailDone';
import { useDispatch } from 'react-redux';
import { messageListApiPost, MessageListApiRequest } from '@common/external/MessageListApi';
import { actions } from '@common/redux/modules/Actions';
import Axios from 'axios';

const App: React.FC = () => {
  // class App extends React.Component<AppProps, any> {
  const dispatch = useDispatch();
  // デバッグ実行のみ下記ヘッダー設定、デバッグ以外の環境ではNginxのリバースプロキシ時にヘッダー設定
  if (process.env.REACT_APP_ENV === 'debug') {
    Axios.defaults.headers.common['module'] = 'customer';
    Axios.defaults.headers.common['userId'] = '-';
    Axios.defaults.headers.common['agencyCd'] = '-';
  }
  useEffect(() => {
    const init = async () => {
      const messageListApiRequest: MessageListApiRequest = {
        level: 1,
        display_flg: true,
        api_flg: false,
        batch_flg: false,
      };
      // マスタ情報取得設定
      const { messageList } = await messageListApiPost(messageListApiRequest);
      dispatch(
        actions.fetchMasterInfo({
          messageList: messageList,
          messageDisplayMethodList: [],
          displayItemList: [],
          pcmCodeDivisionList: [],
          itemImageList: [],
          prohibitedWordMstList: [],
        })
      );
    };
    init();
  }, []); // eslint-disable-line
  return (
    <Switch>
      {/* TOP「メールの配信を停止しますか？」 */}
      <Route exact path={`${SCREEN.MAIL_STOP.URL}/:id/:token`} component={MailDeliveryTop} />
      {/* 「メールの配信を停止しました」 */}
      <Route exact path={`${SCREEN.MAIL_STOP_DONE.URL}/:id/:token`} component={MailDeliveryUnsubscribed} />
      {/* 「サービスが利用できません」 */}
      <Route exact path={`${SCREEN.MAIL_SYS_MAINTE.URL}`} component={SystemMaintenance} />
      {/* 「メールの受信を許諾画面」 */}
      <Route exact path={`${SCREEN.MAIL_OPTIN.URL}/:id/:optInToken`} component={OptinMail} />
      {/* 「メールの受信の許諾完了画面」 */}
      <Route exact path={`${SCREEN.MAIL_OPTIN_DONE.URL}`} component={OptinMailtDone} />
      {/* メールの受信の許諾不正URL画面 */}
      <Route exact path={`${SCREEN.MAIL_OPTIN_ERROR.URL}`} component={OptinMailError} />
      {/* 不正URL画面 */}
      <Route component={NotFound} />
    </Switch>
  );
};

export default withRouter(App);
